$(document).ready(function() {
    /* Select active menu */
    var adress = window.location.pathname;
    first =adress.split('/');
    first = first[1];
    if(adress == '/') {
        $( "#menu > ul > li" ).eq(0).addClass('active');
    } else {
        $( "#menu > ul > li" ).each(function( index ) {
            if($(this).html().indexOf(adress)>0) {
                $( "#menu > ul .active" ).removeClass('active');
                $(this).addClass('active');
                first = null;
                return;
            } else if($(this).html().indexOf(first)>0) {
                $(this).addClass('active');
            } 
        });
    } 
    /* next level menu */
    $('.dropdown-submenu a.test').on("click", function(e){
        $(this).next('ul').toggle();
        e.stopPropagation();
        e.preventDefault();
  });
});
$('document').ready(function(){

    $('#expand1').click(function(){
        $('#expand-content1').toggleClass('contact-widgate__form--label-visible');
        $(this).toggle();
    });

    $('#expand2').click(function(){
        $('#expand-content2').toggleClass('contact-widgate__form--label-visible');
        $(this).toggle();
    });

});
//# sourceMappingURL=default.js.map
